import styled from 'styled-components/macro';
import { hexToRGBA } from 'utils/styles';
import Breakpoints from 'themes/constants/breakpoints';
import Button from 'components/Button/Button';

export const BooksCardBigContainer = styled.div<{ isPrimary: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.wrap.main};
  background: ${({ theme, isPrimary }) => theme.background.card.books[isPrimary ? 'primary' : 'secondary']};
  padding: 12px;
  gap: 12px;
  cursor: pointer;
  @media only screen and (${Breakpoints.MOBILE_L}) {
    padding: 24px;
    gap: 24px;
  }
  @media only screen and (${Breakpoints.LAPTOP_L}) {
    flex-flow: row nowrap;
    padding: 24px;
    gap: 24px;
  }
  @media only screen and (${Breakpoints.DESKTOP_S}) {
    padding: 36px;
  }
`;
export const BooksCardBigCover = styled.div`
  position: relative;
  width: 100%;
  &:after {
    position: absolute;
    inset: 0;
    border-radius: 12px;
    content: "";
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50.13%, rgba(0, 0, 0, 0.60) 100%), transparent;
  }
  @media only screen and (${Breakpoints.LAPTOP_L}) {
    flex-shrink: 0;
    width: 200px;
    &:after {
      display: none;
    }
  }
  @media only screen and (${Breakpoints.DESKTOP_S}) {
    width: 264px;
  }
`;
export const BooksCardBigCoverInner = styled.div`
  position: relative;
  align-self: flex-start;
  flex-shrink: 0;
  width: 100%;
  height: 0;
  padding-bottom: 142%;
  border-radius: 12px;
  box-shadow: ${({ theme }) => `0px 24px 60px 0px ${hexToRGBA(theme.palette.white, 0.5)}`};
  cursor: pointer;
`;
export const BooksCardBigCoverImg = styled.img.attrs({ alt: '' })`
  position: absolute;
  background: ${({ theme }) => theme.background.primary};
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: cover;
`;
export const BooksCardBigCaption = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-shrink: 1;
  gap: 12px;
  color: ${({ theme }) => theme.palette.white};
  line-height: 1.2;
`;
export const BooksCardBigCoverCaption = styled(BooksCardBigCaption)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px;
  text-shadow: ${({ theme }) => `0 0 20px ${hexToRGBA(theme.palette.black, 0.7)}`};
  z-index: 100;
`;
export const BooksCardBigCaptionName = styled.div`
  font-size: 18px;
  font-weight: 500;
  @media only screen and (${Breakpoints.LAPTOP_L}) {
    font-size: 24px;
  }
  @media only screen and (${Breakpoints.DESKTOP_S}) {
    font-size: 30px;
  }
`;
export const BooksCardBigCaptionAuthors = styled.div`
  font-size: 14px;
  font-weight: 400;
  @media only screen and (${Breakpoints.LAPTOP_L}) {
    font-size: 16px;
  }
  @media only screen and (${Breakpoints.DESKTOP_S}) {
    font-size: 18px;
  }
`;
export const BooksCardBigButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  margin-top: auto;
  z-index: 100;
`;
export const BooksCardBigButton = styled(Button)<{ isPrimary?: boolean, color?: string }>`
  background: ${({ theme, isPrimary }) => isPrimary && theme.palette.white};
  border-color: ${({ theme }) => theme.palette.white};
  &, & svg {
    color: ${({ theme, color }) => color || theme.palette.white};
  }
`;
